// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueRouter from 'vue-router'

import compLoader from './components/Loader'

import VueI18n from 'vue-i18n'
import { messages } from './translations/messages'
import { lang } from './translations/lang'

import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'

// 2022-05-20
import { DraggablePlugin, DraggableDirective } from '@braks/revue-draggable'

import VueDraggableResizable from 'vue-draggable-resizable'

// optionally import default styles
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'

import VueDragResize from 'vue-drag-resize'

import vdr from 'vue-draggable-resizable-gorkys'
import 'vue-draggable-resizable-gorkys/dist/VueDraggableResizable.css'

// import VueDragDrop from 'vue-drag-drop'
// import VueDraggable from 'vue-draggable'
// import vDragDrop from 'v-drag-drop'

axios.defaults.baseURL = process.env.VUE_APP_ROOT_API
Vue.config.productionTip = false
Vue.use(VueAxios, axios)
Vue.use(VueRouter)

Vue.use(VueMaterial)
// Vue.use(VueDragDrop)
// Vue.use(VueDraggable)
// Vue.use(vDragDrop)

// const app = Vue.createApp(App)
// app.use(vDragDrop)

// 2022-05-20
Vue.use(DraggablePlugin)
Vue.directive('draggable', DraggableDirective)
// Vue.component('Draggable', Draggable)

Vue.component('vue-draggable-resizable', VueDraggableResizable)

Vue.component('vue-drag-resize', VueDragResize)

Vue.component('vdr', vdr)

Vue.component('app-loader', compLoader)
/**
 * Vue-i18n
 */
const numberFormats = {
  pl: {
    currency: {
      style: 'currency',
      currency: 'PLN',
      currencyDisplay: 'symbol'
    }
  },
  en: {
    currency: {
      style: 'currency',
      currency: 'EUR'
    }
  }
}
Vue.use(VueI18n)
// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: lang, // set locale
  fallbackLocale: 'pl', // when no EN translate
  messages, // set locale messages
  numberFormats
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { App },
  store,
  router,
  i18n,
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js